<template>
    <span>
        <success
            v-if="'subscriptionCancel' === successType"
            @click="$emit('redirect')"
        >
            <template v-slot:image>
                <svg-vue class="add-show-success" icon="delete-success" />
            </template>
            <h2>Thanks for using Fusebox.</h2>
            <p>You and your podcast will be missed! In the meantime, the Pro subscription for your show has been canceled. Should you change your mind, simply log into your dashboard and click Resume.*</p>
            <p>Cheers & happy podcasting!</p>
            <p>-The Fusebox team</p>
            <template v-slot:button>
                See your podcast
            </template>
        </success>
        <success
            v-if="'showDelete' === successType"
            @click="$emit('close')"
        >
            <template v-slot:image>
                <svg-vue class="add-show-success" icon="delete-success" />
            </template>
            <h2>Thank you for using Fusebox Pro Player!</h2>
            <p>Your show has been successfully deleted.</p>
            <template v-slot:button>
                {{ buttonText }}
            </template>
        </success>
        <success
            v-if="'offboardingComplete' === successType"
            @click="$emit('close')"
        >
            <template v-slot:image>
                <svg-vue class="add-show-success" icon="delete-success" />
            </template>
            <h2>Thanks for sharing and using Fusebox Pro Player!</h2>
            <p>Your answers will go a long way in helping us understand the needs and wants of podcasters like you!</p>
            <p>Cheers & happy podcasting!</p>
            <p>-The Fusebox team</p>
            <template v-slot:button>
                {{ buttonText }}
            </template>
        </success>
    </span>
</template>

<script>
import Success from './Success';

export default {
    components: {
        Success,
    },

    props: {
        successType: {
            type: String,
            required: true,
        },
    },

    computed: {
        /**
         * Retursn button text based on main view type
         *
         * @returns  {string}  Button Text
         */
        buttonText() {
            return this.$route.path.includes('shows')
                ? 'Go Back to Shows'
                : 'Go Back to Billing';
        },
    },
};
</script>
